var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.94 12.31H79.56l-7.78-9.28A7.417 7.417 0 0 0 66.1.38H38.02c-2.19 0-4.27.97-5.68 2.65l-7.78 9.28H12.85C6.14 12.31.7 17.75.7 24.46v46.82c0 6.71 5.44 12.15 12.15 12.15h77.08c6.71 0 12.15-5.44 12.15-12.15V24.46c0-6.71-5.44-12.15-12.15-12.15h.01Zm-37.88 57.5c-12.83 0-23.27-10.44-23.27-23.27s10.44-23.27 23.27-23.27 23.27 10.44 23.27 23.27-10.44 23.27-23.27 23.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.07 30.27c-8.97 0-16.27 7.3-16.27 16.27 0 8.97 7.3 16.27 16.27 16.27 8.97 0 16.27-7.3 16.27-16.27 0-8.97-7.3-16.27-16.27-16.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.c1a4516dadfb85a0f5fb72541f44924d.svg";
export { ForwardRef as ReactComponent };